export const downloadUri = (uri: string) => {
  const anchor = document.createElement('a');
  anchor.href = uri;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};
